/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page

      // Update Direct Checkout button with new variant
      // Try to find button within container first, then try document-wide
      var directCheckoutButton = container.querySelector('[data-direct-checkout-button]');
      if (!directCheckoutButton) {
        console.log('Button not found in container, searching document...');
        directCheckoutButton = document.querySelector('[data-direct-checkout-button]');
      }

      if (directCheckoutButton) {
        console.log('Found Direct Checkout button, updating with variant:', variant.id, 'available:', variant.available);
        var checkoutUrl = '/cart/' + variant.id + ':1';
        directCheckoutButton.setAttribute('href', checkoutUrl);
        directCheckoutButton.setAttribute('data-variant-id', variant.id);

        // Update price if shown
        var priceElement = directCheckoutButton.querySelector('[data-button-price]');
        if (priceElement && variant.price) {
          priceElement.textContent = Shopify.formatMoney(variant.price, theme.moneyFormat);
        }

        // Handle availability - update classes and aria attributes
        if (variant.available) {
          directCheckoutButton.classList.remove('button--disabled');
          directCheckoutButton.removeAttribute('aria-disabled');
          directCheckoutButton.style.pointerEvents = '';
          console.log('Direct Checkout button enabled - removed button--disabled class');
        } else {
          directCheckoutButton.classList.add('button--disabled');
          directCheckoutButton.setAttribute('aria-disabled', 'true');
          directCheckoutButton.style.pointerEvents = 'none';
          console.log('Direct Checkout button disabled - added button--disabled class and disabled pointer events');
        }
      } else {
        console.log('Direct Checkout button not found in container or document');
      }
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // Prevent clicks on disabled Direct Checkout buttons
  document.addEventListener('click', function(event) {
    var target = event.target.closest('[data-direct-checkout-button]');
    if (target && (target.classList.contains('button--disabled') || target.getAttribute('aria-disabled') === 'true')) {
      event.preventDefault();
      console.log('Prevented click on disabled Direct Checkout button');
      return false;
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
